import { AdvertiserReport } from "components/Report/AdvertiserReport/AdvertiserReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/")({
    component: AdvertisersReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportAdvertiser],
        showInSideMenu: false,
        label: "pages.report.advertiser.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.advertiser.title"),
        };
    },
});

function AdvertisersReportPage() {
    const { t } = usePaldockTranslation("pages.report.advertiser");
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems} title={t("title")}>
            <AdvertiserReport />
        </TenantPage>
    );
}
